import {ConfirmAppointmentGenericSellerError} from './ConfirmAppointmentGenericSellerError.js'
import {ContactValidationSellerError} from './ContactValidationSellerError.js'
import {EmptyEmailSellerError} from './EmptyEmailSellerError.js'
import {EmptyNameSellerError} from './EmptyNameSellerError.js'
import {GenericSellerError} from './GenericSellerError.js'
import {GetCloseDealersGenericSellerError} from './GetCloseDealersGenericSellerError.js'
import {GetCloseDealersNotFoundSellerError} from './GetCloseDealersNotFoundSellerError.js'
import {GetInstantOfferDetailsGenericSellerError} from './GetInstantOfferDetailsGenericSellerError.js'
import {GetInstantOfferDetailsNotFoundSellerError} from './GetInstantOfferDetailsNotFoundSellerError.js'
import {GetInstantOfferGenericSellerError} from './GetInstantOfferGenericSellerError.js'
import {GetInstantOfferNotFoundSellerError} from './GetInstantOfferNotFoundSellerError.js'
import {GetRecommendedPriceGenericSellerError} from './GetRecommendedPriceGenericSellerError.js'
import {InvalidAppointmentRequestSellerError} from './InvalidAppointmentRequestSellerError.js'
import {InvalidEmailSellerError} from './InvalidEmailSellerError.js'
import {InvalidPhoneSellerError} from './InvalidPhoneSellerError.js'
import {InvalidRequestSellerError} from './InvalidRequestSellerError.js'
import {InvalidSellerRequestSellerError} from './InvalidSellerRequestSellerError.js'
import {TermsAndConditionsNotAcceptedSellerError} from './TermsAndConditionsNotAcceptedSellerError.js'

export class SellerErrorsFactory {
  static confirmAppointmentGenericSellerError = message => new ConfirmAppointmentGenericSellerError(message)

  static getInstantOfferDetailsGenericSellerError = message => new GetInstantOfferDetailsGenericSellerError(message)

  static getInstantOfferDetailsNotFoundSellerError = message => new GetInstantOfferDetailsNotFoundSellerError(message)

  static contactValidationSellerError = ({errors}) =>
    new ContactValidationSellerError({
      errors
    })

  static emptyNameSellerError = () => new EmptyNameSellerError()

  static emptyEmailSellerError = () => new EmptyEmailSellerError()

  static genericSellerError = message => new GenericSellerError(message)

  static contactModelSellerGenericError = ({errors}) => new GenericSellerError({errors})

  static getCloseDealersGenericSellerError = message => new GetCloseDealersGenericSellerError(message)

  static getCloseDealersNotFoundSellerError = message => new GetCloseDealersNotFoundSellerError(message)

  static getInstantOfferGenericSellerError = message => new GetInstantOfferGenericSellerError(message)

  static getInstantOfferNotFoundSellerError = message => new GetInstantOfferNotFoundSellerError(message)

  static getRecommendedPriceGenericSellerError = message => new GetRecommendedPriceGenericSellerError(message)

  static invalidAppointmentRequestSellerError = message => new InvalidAppointmentRequestSellerError(message)

  static invalidEmailSellerError = () => new InvalidEmailSellerError()

  static invalidPhoneSellerError = () => new InvalidPhoneSellerError()

  static invalidRequestSellerError = message => new InvalidRequestSellerError(message)

  static invalidSellerRequestSellerError = message => new InvalidSellerRequestSellerError(message)

  static termsAndConditionsNotAcceptedSellerError = () => new TermsAndConditionsNotAcceptedSellerError()
}
